import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { QLinearGradient } from 'qunar-react-native';
import Icon from '../../../Icon';
import utils from '../utils';
import { DEVICE_WIDTH } from '../../../../Constant/size';
import { enabledStyle, disabledStyle } from '../commonStyles';

const statusMap: { [propName: string]: string } = {
    10: 'isWarning',
    11: 'isWarning',
    500050: 'isWarning'
};

const appActionMap = {
    pay: true,
    insure: true
};

const titleMap: { [propName: string]: string } = {
    2811: '机票（抢票订单）'
};

interface Props {
    data: {
        flightList: FlightItemModel[];
        hasBackUp: boolean;
        _disable: boolean;
        orderType: number;
        childTicket:any;
    };
}

const GRADIENT_OUTBOUND = ['#69D9F3', '#43B8DE'];
const GRADIENT_RETURN_TICKET = ['#71DF5E', '#54C042'];

class Flight extends Component<Props> {
    public static formatData = (data: any) => {
        const newData = { ...data };
        // title
        newData.title = newData.productType || titleMap[data.sysCode] || '机票';
        // icon
        newData.iconfont =
            data.orderType === 2705001 && data.businessTitle ? '\uf20c' : '\uf1ea';
        newData.iconColor = data.orderType === 2811002 ? '#3895FA' : '#22cad3';
        // 状态
        newData._orderStatus = statusMap[newData.status];
        // 按钮
        newData.actionInfos = utils.buildActionInfos(newData.appAction, appActionMap);
        // 价格
        newData.fixPrice = utils.fixPrice(newData.price, newData.currency);
        newData.fixConvertPrice = utils.fixPrice(newData.convertPrice);
        newData.currency = (newData.currency || '').trim();
        newData.hasProbability = newData.probability;
        if (newData.flightList) {
            newData.flightList = newData.flightList.map((flight: any) => {
                const newFlight = {
                    ...flight
                };
                newFlight.addOrMinus = newFlight.days > 0 ? '+' : ''; // 负号自带
                newFlight.flightLines = buildFlightLines(newFlight);
                if (!newFlight.isMixUp) {
                    if (newFlight.showDeparture) {
                        newFlight.timeLine = utils.buildFuzzyTimeLine(newFlight.showDeparture, newFlight.showArrival)
                    } else {
                        newFlight.timeLine = utils.buildTimeLine(
                            newFlight.departure,
                            newFlight.arrival
                        );
                    }
                } else {
                    const mixUpInfo = utils.buildMixUpInfo(newFlight.mixUp);
                    newFlight.mixUpInfo = utils.bulidMixTimeLineMore(mixUpInfo);
                }

                if (newFlight.transferNum && newFlight.transferNum <= 1) {
                    // 只有中转1次以下显示中转次数
                    newFlight.transferNum = undefined;
                }
                return newFlight;
            });
        }
        if (newData.hasProbability) {
            const lastFlight =
                newData.flightList &&
                newData.flightList.length > 0 &&
                newData.flightList[newData.flightList.length - 1];
            lastFlight.hasProbability = true;
            lastFlight.probability = `${parseInt(String(Number(newData.probability) * 100), 10)}%`;
        }

        return newData;
    };

    public render() {
        const { data: { flightList, hasBackUp, _disable, orderType, childTicket, outboundLabel, returnTicketLabel} = {} } = this.props;
        const styles = _disable ? disabledStyle : enabledStyle;

        const isAppointment = orderType === 2811002;
        return (
            <View style={styles.left}>
                {flightList.length > 0 &&
                    flightList.map((flightItem: FlightItemModel, i: number) => (
                        <View
                            style={
                                i === flightList.length - 1 ? null : styles.ticketItemWithSiblings
                            }
                            key={i}
                        >
                            <View style={[styles.rowWithIcon,]} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.FLIGHT_DEP_CITY)}>
                                {/* from to */}
                                {flightItem.from || flightItem.to ? (
                                    flightItem.isTransfer ? (
                                        <View style={styles.transferRow}>
                                            {Boolean(flightItem.from) && (
                                                <Text
                                                    style={[
                                                        styles.newOrderTitle,
                                                        {
                                                            maxWidth:
                                                                (DEVICE_WIDTH -
                                                                    12 * 2 -
                                                                    16 * 2 -
                                                                    85 -
                                                                    (flightItem.transferNum
                                                                        ? 66
                                                                        : 50)) *
                                                                0.5
                                                        }
                                                    ]}
                                                    numberOfLines={1}
                                                >
                                                    {flightItem.to
                                                        ? `${flightItem.from}  `
                                                        : `${flightItem.from}`}
                                                </Text>
                                            )}
                                            {Boolean(flightItem.from && flightItem.to) && (
                                                <View style={styles.transferWrapper}>
                                                    <Icon
                                                        code="&#xe6d7;"
                                                        style={[styles.transferIcon, { top: 1 }]}
                                                        size={12}
                                                    />
                                                    <View style={styles.transferTextWrapper}>
                                                        <Text
                                                            style={[
                                                                styles.transferText,
                                                                { backgroundColor: 'transparent' }
                                                            ]}
                                                        >
                                                            {`转${
                                                                flightItem.transferNum
                                                                    ? `${flightItem.transferNum}`
                                                                    : ''
                                                            }`}
                                                        </Text>
                                                    </View>
                                                    <Icon
                                                        code="&#xe6d8;"
                                                        style={[
                                                            styles.transferIcon,
                                                            {
                                                                marginLeft: 2,
                                                                top: 1
                                                            }
                                                        ]}
                                                        size={12}
                                                    />
                                                </View>
                                            )}
                                            {Boolean(flightItem.to) && (
                                                <Text
                                                    style={[
                                                        styles.newOrderTitle,
                                                        {
                                                            maxWidth:
                                                                (DEVICE_WIDTH -
                                                                    12 * 2 -
                                                                    16 * 2 -
                                                                    85 -
                                                                    (flightItem.transferNum
                                                                        ? 66
                                                                        : 50)) *
                                                                0.5
                                                        }
                                                    ]}
                                                    numberOfLines={1}
                                                >
                                                    {flightItem.from
                                                        ? `  ${flightItem.to}`
                                                        : `${flightItem.to}`}
                                                </Text>
                                            )}
                                        </View>
                                    ) : (
                                        <Text style={styles.newOrderTitle} numberOfLines={2}>
                                            {Boolean(flightItem.from) &&
                                                `${flightItem.from}${flightItem.to ? '  ' : ''}`}
                                            {Boolean(flightItem.from && flightItem.to) && (
                                                <Icon code="&#xe6c2;" size={14} />
                                            )}
                                            {Boolean(flightItem.to) &&
                                                `${flightItem.from ? '  ' : ''}${flightItem.to}`}
                                        </Text>
                                    )
                                ) : null}
                                {/*  儿童票 */}
                                {
                                    childTicket && (
                                        <View style={[styles.childTicketWrapper,{backgroundColor:'#F3F6F8'}]}>
                                            <Text style={styles.childTicketText}>儿童票</Text>
                                        </View>
                                    )
                                }
                                {/* 去程或者返程 label */}
                                {
                                    this.getFlightLabel(flightItem, outboundLabel, returnTicketLabel, styles)
                                }
                            </View>
                            {flightItem.isMixUp ? (
                                flightItem.mixUpInfo.map((mixInfo: MixInfoModel, index: number) => {
                                    if (!mixInfo.timeLine) {
                                        return null;
                                    }
                                    return (
                                        <Text
                                            key={index}
                                            numberOfLines={1}
                                            style={styles.newOrderSubTitle}
                                            {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.FLIGHT_DEP_DATE)}
                                        >
                                            {`${mixInfo.timeLine}${hasBackUp ? '等' : ''}`}
                                            {Boolean(mixInfo.days) && (
                                                <Text style={styles.oneMoreDay}>
                                                    {` ${mixInfo.addOrMinus}${mixInfo.days}天`}
                                                </Text>
                                            )}
                                        </Text>
                                    );
                                })
                            ) : (
                                <Text
                                    numberOfLines={1}
                                    style={styles.newOrderSubTitle}
                                    {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.FLIGHT_DEP_DATE)}
                                >
                                    {`${flightItem.timeLine}${hasBackUp ? '等' : ''}`}
                                    {Boolean(flightItem.days) && (
                                        <Text style={styles.oneMoreDay}>
                                            {` ${flightItem.addOrMinus}${flightItem.days}天`}
                                        </Text>
                                    )}
                                    {Boolean(isAppointment) && (
                                        <Text numberOfLines={1} style={styles.newOrderSubTitle}>
                                            {`${flightItem.date || ''} ${flightItem.sectionName ||
                                                ''}`}
                                        </Text>
                                    )}
                                </Text>
                            )}
                            {flightItem.flightLines &&
                                flightItem.flightLines.length > 0 &&
                                flightItem.flightLines.map((line: string, index: number) => (
                                    <Text
                                        numberOfLines={1}
                                        style={styles.newOrderSubTitle}
                                        key={index}
                                        {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.FLIGHT_FLIGHTNO)}
                                    >
                                        {`${line}${hasBackUp ? '等' : ''}`}
                                    </Text>
                                ))}
                            {Boolean(flightItem.hasProbability) && (
                                <Text
                                    numberOfLines={1}
                                    style={styles.newOrderSubTitle}
                                >
                                    {`预约成功率 ${flightItem.probability}`}
                                </Text>
                            )}
                        </View>
                    ))}
            </View>
        );
    }

    public getFlightLabel = (flightItem: FlightItemModel, outboundLabel: string, returnTicketLabel: string, styles: any) => {
        if(!(flightItem.isReturnTicket || flightItem.isInbound || outboundLabel || returnTicketLabel)) {
            // 无任何往返标识
            return null;
        }
        const isOutbound = flightItem.isInbound || outboundLabel;
        const outboundText = flightItem.isInbound ? '去程' : outboundLabel;
        const returnText = flightItem.isReturnTicket ? '返程' : returnTicketLabel;
        return <QLinearGradient
            colors={isOutbound ? GRADIENT_OUTBOUND : GRADIENT_RETURN_TICKET}
            style={styles.childTicketWrapper}
            start={{x: 1.0, y: 0}}
            end={{x: 0, y: 0}}>
            <Text style={[styles.childTicketText, {color:'#fff'}]}>{isOutbound ? outboundText : returnText}</Text>
        </QLinearGradient>;
    }
}

const buildFlightLines = (flight: {
    hasShareFlight: boolean;
    flights: { originFlight: string; shareFlight: string }[];
}) => {
    let result = [];
    const flightNoList: string[] = [];
    if (!flight.hasShareFlight) {
        flight.flights &&
            flight.flights.forEach((info) => {
                info.originFlight && flightNoList.push(info.originFlight);
            });
        if (flightNoList.length > 0) {
            result.push(flightNoList.join('/') || '');
        }
    } else {
        flight.flights &&
            flight.flights.forEach((info) => {
                if (info.originFlight || info.shareFlight) {
                    flightNoList.push(
                        `${info.originFlight ? `${info.originFlight}   ` : ''}${
                            info.shareFlight ? `实际乘坐  ${info.shareFlight}` : ''
                        }`
                    );
                }
            });
        result = flightNoList;
    }
    return result;
};

export default Flight;

interface MixInfoModel {
    timeLine: string;
    isReturnTicket: boolean;
    isInbound: boolean;
    days: string;
    addOrMinus: string;
}

interface FlightItemModel {
    isInbound: boolean;
    isReturnTicket: boolean;
    from: string;
    to: string;
    isTransfer: boolean;
    transferNum: number;
    isMixUp: boolean;
    mixUpInfo: MixInfoModel[];
    timeLine: string;
    days: string;
    addOrMinus: string;
    date: string;
    sectionName: string;
    flightLines: string[];
    hasProbability: boolean;
    probability: string;
    childTicket:string;
}
